import { useEffect, useState } from "react";
import CardSeplagScrol from "../../../../components/CardSeplag/CardSeplagScrol";
import QuestionarioSeplag from "../../../../components/QuestionarioSeplag";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import { useHistory } from "react-router-dom";
import { buscarApuracaoIndicadores, salvarAvaliacaoPrograma } from "../../../../service/Rag/AvaliacaoPrograma";

import { printToast } from "../../../../config/global";

const AvaliacaoProgramaRagResultado = (props) => {
  const [apuracao, setApuracao] = useState([]);
  const [headerDescIndicador, setHeaderDescIndicador] = useState([]);
  const [listaAnos, setListaAnos] = useState([]);
  const [campos, setCampos] = useState(JSON.parse(props.questionario));

  let history = useHistory();

  function formatarValor(valor) {
    if (valor === undefined || valor === null || valor === "0.00") {
      return " - ";
    }
    return valor.toLocaleString("pt-BR", { minimumFractionDigits: 3 });
  }

  useEffect(() => {
    
    let idenPPAAux = props.PPA; //recupera o id do PPA
    //console.log("Dia33:",idenPPAAux, " ", props.dadosItemPrograma.dadosItemRag, " ", props.dadosItemPrograma.dadosItemRag.idenPrograma)
    //console.log("DadosPPA",props.PPA)
    //buscarApuracaoIndicadores(idenPPAAux, props.dadosItemPrograma.dadosItemRag.codgPrograma).then((res) => {
      buscarApuracaoIndicadores(props.PPA, props.dadosItemPrograma.dadosItemRag.idenPrograma).then((res) => {  
      /*
                    Remontando o json que é vindo da API. Pois preciso do json formatado de um certo modo para ser possivel montar na tela
                    caso queria ver como está chegando o json para entender o  codigo é só descomentar a linha a baixo.

                    console.log( res.data)

                    Preciso de uma lista de anos para montar o cabeçalho
                    e atraves dos atributos pos1,pos2,pos3 e pos4 coloca-se os valores precisos em cada ano.

                */
      //debugger
      const sortedList = res.data.sort((a, b) => a.codgObjetivo - b.codgObjetivo);

      let resultadoIndicador = null;

      let listaResultadoIndicador = [];
      let v_listaAnos = [];

      let obj = {
        codgObjetivo: 0,
        codgIndicador: 0,
        indicador: null,
        objetivo: null,
      };
      let cont = 0;
      
      res.data.forEach((current) => {
        //Caso a variavel resultadoIndicador for nulo quer dizer q estou na primeira iteração
        if (resultadoIndicador == null) {
          resultadoIndicador = current;
          obj.indicador = resultadoIndicador.indicador ? resultadoIndicador.indicador : null;
          obj.objetivo = resultadoIndicador.objetivo ? resultadoIndicador.objetivo : null;
        } else if (
          current.codgObjetivo !== resultadoIndicador.codgObjetivo ||
          current.codgIndicador !== resultadoIndicador.codgIndicador
        ) {
          /*
                                Caso o ca   mpo objetivo ou indicador do objetivo current esteja diferente do objetivo ou indicador
                                do objeto resultadoIndicador quer dizer que deve ser adicionado uma nova linha na tabela.
                                Por isso que dou um .push(obj) para salvar oq foi feito e começar um novo obj
                            */

          listaResultadoIndicador.push(obj);

          resultadoIndicador = current;
          cont = 0;
          obj = {
            indicador: resultadoIndicador.indicador ? resultadoIndicador.indicador : null,
            objetivo: resultadoIndicador.objetivo ? resultadoIndicador.objetivo : null,
          };
        }

        if (!obj.objetivo && current.objetivo) {
          obj.objetivo = current.objetivo;
        }

        if (!obj.indicador && current.indicador) {
          obj.indicador = current.indicador;
        }

        // Código para montar a lista de anos no cabeçalho da tabela
        if (!v_listaAnos.includes(current.ano)) {
          v_listaAnos.push(current.ano);
        }

        if (current.indicador != null && current.indicador.descIndicador != null) {
          headerDescIndicador[current.indicador.codgIndicador] =
            current.indicador.codgIndicador + " - " + current.indicador.descIndicador;
        }

        // Codigo para adicionar o valor previsto, realizado e a data de apuração em cada coluna do ano
        // hj é permitido só colocar 4 anos por exemplo 2020, 2021, 2022 e 2023
        cont++;

        // console.log(v_listaAnos + " " + cont + " " + current.ano)

        if (cont === 1) obj = { ...obj, pos1: current };
        if (cont === 2) obj = { ...obj, pos2: current };
        if (cont === 3) obj = { ...obj, pos3: current };
        if (cont === 4) obj = { ...obj, pos4: current };
      });

      // Como a iteração acaba preciso adicionar o obj q estava tratando na ultima iteração
      listaResultadoIndicador.push(obj);
      setApuracao(listaResultadoIndicador);
      setListaAnos(v_listaAnos);
    });
  }, []);

  const dataApuracaoTemplatePos1 = (rowData) => {
    if (rowData === undefined || rowData === null) return "*";

    return rowData.pos1.dataApuracao ? rowData.pos1.dataApuracao : "--/--/----";
  };
  const dataApuracaoTemplatePos2 = (rowData) => {
    if (rowData === undefined || rowData === null) return "*";

    return rowData.pos2?.dataApuracao ? rowData.pos2.dataApuracao : "--/--/----";
  };
  const dataApuracaoTemplatePos3 = (rowData) => {
    if (rowData === undefined || rowData === null) return "*";

    return rowData?.pos3?.dataApuracao ? rowData?.pos3?.dataApuracao : "--/--/----";
  };
  const dataApuracaoTemplatePos4 = (rowData) => {
    if (rowData === undefined || rowData === null) return "*";

    return rowData?.pos4?.dataApuracao ? rowData?.pos4?.dataApuracao : "--/--/----";
  };

  let headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header="Objetivo do Programa" rowSpan={2} />
        <Column header="Indicador do Objetivo" rowSpan={2} />
        <Column header={listaAnos[0]} colSpan={3} align="center"/>
        <Column header={listaAnos[1] !== undefined ? listaAnos[1] : (listaAnos[0] + 1)} colSpan={3} align="center"/>
        <Column header={listaAnos[2] !== undefined ? listaAnos[2] : (listaAnos[0] + 2)} colSpan={3} align="center"/>
        <Column header={listaAnos[3] !== undefined ? listaAnos[3] : (listaAnos[0] + 3)} colSpan={3} align="center"/>
      </Row>
      <Row>
        <Column header="Previsto" />
        <Column header="Realizado" />
        <Column header="Data da Apuração" />
        <Column header="Previsto" />
        <Column header="Realizado" />
        <Column header="Data da Apuração" />
        <Column header="Previsto" />
        <Column header="Realizado" />
        <Column header="Data da Apuração" />
        <Column header="Previsto" />
        <Column header="Realizado" />
        <Column header="Data da Apuração" />
      </Row>
    </ColumnGroup>
  );

  const voltar = () => {
    history.push({ pathname: "/raglancamentos", state: {} });
  };

  const salvar = () => {
    let invalid = false;
    let v_campos = campos.map((questao,i) => {

      if(questao.data == null || questao.data == ""){
        printToast({ severity:"error", summary: "OBRIGATÓRIO", detail: `A questão ${i + 1} dessa tela deve ser respondida. Por favor, verifique.` });
        invalid = true;
        return { ...questao };
      }else if(questao.valrRespostaItemQuest !== null || questao.valrRespostaItemQuest !== ""){
        questao.valrRespostaItemQuest = questao.data;
        return { ...questao };
      }
    });

    let codigoItem = campos[0].codigoItemRag;
    let percentualQuestionarios = 'teste'
    !invalid && salvarAvaliacaoPrograma(codigoItem, v_campos).then((res) => {
      props.setCamposQuestionarioResultado(JSON.stringify(campos));      
      props.aba(true);  //Controle para sinalizar que a Aba Identificacao deve realizar a busca do percentual de preenchimento do acao
      // printToast({ summary: "Ação Efetuada", detail: `Análise dos resultados salva com sucesso. Percentual de preenchimento ${percentualQuestionarios}` });      
      printToast({ summary: "Ação Efetuada", detail: `Análise dos resultados salva com sucesso.` });
    });
  };

  const salvarDadosAtualizados = (e) => {
    props.setCamposQuestionarioResultado(JSON.stringify(e));
    setCampos(e);
  };

  const bodyTemplateObjetivo = (rowData) => {
    return `${rowData.objetivo.codgObjetivo} - ${rowData.objetivo.nomeObjetivo}`;
  };

  const bodyTemplateObjetivoIndicador = (rowData) => {
    //return ` ${rowData.indicador.codgIndicador} - ${rowData.indicador.descIndicador}`;
    //return ` ${rowData.pos4.indicador.codgIndicador} - ${rowData.pos4.indicador.descIndicador}`;
    return headerDescIndicador[rowData.indicador.codgIndicador];
  };

  return (
    <>
      <CardSeplagScrol title="Análise dos Resultados">        
        <DataTable value={apuracao} stripedRows showGridlines headerColumnGroup={headerGroup} responsiveLayout="scroll">
          <Column body={bodyTemplateObjetivo} header="Objetivo do Programa" />
          <Column body={bodyTemplateObjetivoIndicador} header="Indicador do Objetivo" />
          <Column
            field="pos1.valrMetaIndicadorObjetivo"
            body={(e) => formatarValor(e.pos1.valrMetaIndicadorObjetivo)}
            header="Previsto"
          />
          <Column field="pos1.valrApurado" 
            body={(e) => formatarValor(e.pos1.valrApurado)} 
            header="Realizado" 
          />
          <Column field="indicador.descIndicador" 
            body={dataApuracaoTemplatePos1} 
            header="Data da Apuração" 
          />
          <Column
            field="pos2.valrMetaIndicadorObjetivo"
            body={(e) => formatarValor(e?.pos2?.valrMetaIndicadorObjetivo)}
            header="Previsto"
          />
          <Column field="pos2.valrApurado" 
            body={(e) => formatarValor(e?.pos2?.valrApurado)} 
            header="Realizado" 
          />
          <Column 
            body={dataApuracaoTemplatePos2} 
            header="Data da Apuração" 
          />
          <Column
            field="pos3.valrMetaIndicadorObjetivo"
            body={(e) => formatarValor(e?.pos3?.valrMetaIndicadorObjetivo)}
            header="Previsto"
          />
          <Column
            field="pos3.valrApuradopos3.valrApurado"
            body={(e) => formatarValor(e?.pos3?.valrApurado)}
            header="Realizado"
          />
          <Column body={dataApuracaoTemplatePos3} 
            header="Data da Apuração" 
          />
          <Column
            field="pos4.valrMetaIndicadorObjetivo"
            body={(e) => formatarValor(e?.pos4?.valrMetaIndicadorObjetivo)}
            header="Previsto"
          />
          <Column field="pos4.valrApurado" 
            body={(e) => formatarValor(e?.pos4?.valrApurado)} 
            header="Realizado" 
          />
          <Column 
            body={dataApuracaoTemplatePos4} 
            header="Data da Apuração" 
          />
        </DataTable>
        <QuestionarioSeplag
          campos={campos}
          setCampos={salvarDadosAtualizados}
          condicao={props.condicao}
          IsMaximoCaracteres={true}
          qtdMaxCaracteres={15000}
          isDisabled={!props.podeAvaliarPrograma}
        ></QuestionarioSeplag>

      <br />
      </CardSeplagScrol>
        <br />
        <div className="p-fluid grid">
          <div className="field col-12 md:col-8 ">&nbsp;</div>
          <div className="field col-12 md:col-2 ">
            <Button label="Voltar" className="p-button-secondary" onClick={voltar} />
          </div>

        <div className="field col-12 md:col-2 ">
          <Button label="Salvar" className="p-button-success" onClick={salvar} 
          disabled={!props.podeAvaliarPrograma}
           />
        </div>
        {/*<div className="field col-12 md:col-2 ">
                    <Button label="Remover" className="p-button-danger"  onClick={remover} />
                </div>*/}
      </div>
        <br />
        <label>
          <p>
              <sup>(1)</sup> <b>Público-alvo transversal</b>: grupos da
              sociedade com necessidades específicas atendidos por diversas
              políticas públicas setoriais, independente da estrutura organizacional
              da Administração Pública, classificados como: adolescentes,
              comunidades tradicionais e quilombolas, crianças, juventude,
              mulheres, negros, pessoas com deficiência, pessoas idosas, população
              em situação de rua, população LGBTQIAPN+ e povos indígenas
          </p>
          <p>
              <sup>(2)</sup> <b>ODS</b>: os Objetivos de Desenvolvimento
              Sustentável (17 objetivos globais e 169 metas) e a Agenda 2030/ONU
              consistem num apelo global para acabar com a pobreza, proteger o
              meio ambiente e o clima, e garantir que as pessoas, em todos os
              lugares, possam desfrutar de paz e prosperidade
          </p>
        </label>
    </>
  );
};

export default AvaliacaoProgramaRagResultado;
